import { Injectable } from '@angular/core';
declare var clarity;

@Injectable({
  providedIn: 'root'
})
export class ClarityEventsService {
  constructor() { }
  adminRegister(data){
    let userEmail = data && data.email ? data.email : '';
    let userOrganization = data && data.organization ? data.organization : '';
    let userActivationUniqueName = data && data.activationUniqueName ? data.activationUniqueName : '';
    clarity("set", "Activation Unique name", userActivationUniqueName);
    clarity("set", "Organization", userOrganization);
    clarity("set", "Email", userEmail);
  }
}